export default __webpack_public_path__ + "static/media/payment-method-mobile-active.12e4d69a.svg";